import { render, staticRenderFns } from "./bidder-margin.vue?vue&type=template&id=3604b0a7&scoped=true"
import script from "./bidder-margin.vue?vue&type=script&lang=js"
export * from "./bidder-margin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604b0a7",
  null
  
)

export default component.exports